const getConfig = (seriesData, height) => ({
  chart: {
    zoomType: 'xy',
    height
  },
  title: {
    text: ''
  },
  xAxis: {
    type: 'datetime',
    labels: { enabled: false }
  },
  yAxis: {
    title: { text: '' },
    labels: { enabled: false }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    crosshairs: {
      width: 2,
      dashStyle: 'shortdot'
    },
    headerFormat: '',
    pointFormat: '<b>{series.name} {point.value:.2f} | {point.name}</b>'
  },
  plotOptions: {
    series: {
      animation: false,
      marker: {
        enabled: false
      },
      turboThreshold: 0
    }
  },
  series: seriesData,
  credits: {
    enabled: false
  }
});

export default getConfig;
